import { Box, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, FormErrorMessage, useDisclosure, Select, } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import IdentityDetailLogo from "../../../../../assets/images/IdentityDetailLogo.svg";
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { EmployeePersonalInfo } from "./modal";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BasicDetal } from "./modal";
import { useAuth } from "../../../../../hooks/useAuth";
import { showDate } from "../../../../../utilities/helper";

interface Props {
    employeeId: number | null;
    personalDetail?: EmployeePersonalInfo;
    reload: () => void;
}

export interface IBasicDetails {
    empId?: number | null;
    gender_Id: number;
    blood_Group_Id: number;
    dob: string;
};

const BasicDetails = ({ employeeId, personalDetail, reload }: Props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [genderDropdown, setGenderDropdown] = useState<any>([])
    const [bloodDropdown, setBloodDropdown] = useState<any>([])
    const { hasPermission, loginObj } = useAuth();

    const loggedInEmployeeId = loginObj?.employeeId;

    const isOwnProfile = employeeId === loggedInEmployeeId;

    const GenderSchema: any = yup.object().shape({
        gender_Id: yup.number().required("Gender is required").typeError("Gender is required"),
        blood_Group_Id: yup.number().required("Blood Group is required").typeError("Blood Group is required"),
        dob: yup.string().required("Date of Birth is required"),
    })

    const { control, handleSubmit, formState: { errors, isSubmitting }, reset } = useForm<IBasicDetails>({
        resolver: yupResolver(GenderSchema),
        defaultValues: {
            gender_Id: personalDetail?.gender_Id || 0,
            blood_Group_Id: personalDetail?.blood_Group_Id || 0,
            dob: personalDetail?.dob || "",
        },
    });

    function handleEditClick() {
        reset({
            gender_Id: personalDetail?.gender_Id,
            blood_Group_Id: personalDetail?.blood_Group_Id,
            dob: personalDetail?.dob ? personalDetail?.dob.split("T")[0] : "",
        });
        onOpen();
    }

    const onSubmit = async (data: IBasicDetails) => {
        data.empId = employeeId;

        let endpoint = `Hrlense_Employee/personalDetail/${employeeId}`;
        const response = await fetchApi(endpoint, "PUT", data, null, "Basic Details Updated");
        if (response) {
            reload();
            onClose();
        }
    };

    const GenderDropDown = async () => {
        const response = await fetchApi("DropDown/gender", "GET", null, "");
        if (response) {
            setGenderDropdown(response);
        }
    };
    const BloodGroupDropDown = async () => {
        const response = await fetchApi("DropDown/bloodGroup", "GET", null, "");
        if (response) {
            setBloodDropdown(response);
        }
    };
    useEffect(() => {
        GenderDropDown();
        BloodGroupDropDown()
    }, [employeeId]);

    return (
        <>

            <Box pt={2} mb={6} className="main">
                <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                    <Flex align="center" gap={3}>
                        <Image src={IdentityDetailLogo} alt={"Benifits & ID Numberss"} />
                        <Text className="font-poppins text_sm text_medium col">
                            Basic Details
                        </Text>
                    </Flex>
                    {(hasPermission('Employee', 'UpdateEmployeesBasicDetail') || (hasPermission('Employee', 'UpdateOwnBasicDetail') && isOwnProfile)) &&
                        (<IconButton aria-label="Edit" icon={<Image src={EditLogo} />} variant="none" onClick={() => handleEditClick()} />)}
                </Flex>

                <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                    {BasicDetal.map((data, index) => (
                        <Grid key={index} templateColumns="1fr 1fr" alignItems="center" mb={2}>
                            <Text
                                className="font-poppins text_sm text_medium"
                                color="rgba(102, 102, 102, 1)"
                              
                            >
                                {data?.label}
                            </Text>
                            <Text className="font-poppins text_sm text_medium col">
                                {data.key === 'dob' ?
                                    <span>
                                        {(data?.key ? data.modifier(personalDetail?.[data?.key]) : personalDetail?.[data?.key])}
                                    </span>
                                    :
                                    <span> {data?.modifier
                                        ? data.modifier(personalDetail?.[data?.key])
                                        : personalDetail?.[data?.key]}</span>
                                }
                            </Text>
                        </Grid>
                    ))}
                    {/* <Divider mt={2} /> */}
                </Box>
            </Box>


            {/* Drawer for editing */}
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Update Basic Details</DrawerHeader>
                    <DrawerBody>
                        <form onSubmit={handleSubmit(onSubmit)}>

                            <FormControl isInvalid={!!errors.gender_Id} isRequired mb={4}>
                                <FormLabel>Gender</FormLabel>
                                <Controller
                                    name="gender_Id" control={control}
                                    render={({ field }) => (
                                        <Select {...field} placeholder="Select Gender">
                                            {genderDropdown.map((opt: any) => (
                                                <option key={opt.id} value={opt.id}>
                                                    {opt.gender}
                                                </option>
                                            ))}
                                        </Select>
                                    )}
                                />
                                <FormErrorMessage> {errors.gender_Id?.message} </FormErrorMessage>
                            </FormControl>


                            <FormControl isInvalid={!!errors.blood_Group_Id} isRequired mb={4}>
                                <FormLabel> Blood Group </FormLabel>
                                <Controller
                                    name="blood_Group_Id" control={control}
                                    render={({ field }) => (
                                        <Select {...field} placeholder="Select Blood Group">
                                            {bloodDropdown.map((opt: any) => (
                                                <option key={opt.id} value={opt.id}>
                                                    {opt.bloodGroup}
                                                </option>
                                            ))}
                                        </Select>
                                    )}
                                />
                                <FormErrorMessage>{errors.blood_Group_Id?.message}</FormErrorMessage>
                            </FormControl>

                            <FormControl mb={4} isInvalid={!!errors.dob} isRequired>
                                <FormLabel>Date Of Birth</FormLabel>
                                <Controller
                                    name="dob"
                                    control={control}
                                    render={({ field }) => {
                                        const today = new Date();
                                        today.setFullYear(today.getFullYear() - 18);
                                        const maxDate = today.toISOString().split("T")[0];

                                        return <Input type="date" {...field} max={maxDate} />;
                                    }}
                                />
                                <FormErrorMessage>{errors.dob?.message}</FormErrorMessage>
                            </FormControl>


                            <Box mt={6} textAlign="right">
                                <Button type="submit" className="btn_theme btn_theme:hover" isLoading={isSubmitting}>
                                    Update
                                </Button>
                            </Box>
                        </form>

                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>

    );
};

export default BasicDetails;
